/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _localStorageService: LocalStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this._localStorageService.getItem('authToken');
    const storedLang = this._localStorageService.getItem('language');
    const acceptLanguage = storedLang === 'es' ? 'es-MX' : 'en-US';

    const headersToSet: { [name: string]: string } = {
      'Accept-Language': acceptLanguage,
    };

    if (token && !req.url.includes('maps.googleapis.com')) {
      headersToSet['SessionToken'] = `${token}`;
    }

    const clonedReq = req.clone({
      setHeaders: headersToSet,
    });

    return next.handle(clonedReq);
  }
}
